export const baseOssUrl = "https://sanyglobal.sany-img.com";
const url = window.location.href;
const isProduction =
  url.indexOf(".sanyglobal.com") > -1 || url.indexOf(".sanygroup.com") > -1;
// const isProduction=true;
// const isProduction=url.indexOf("localhost")>-1;
// export const AUTH_URL = isProduction ? "https://oauthapi.sanyglobal.com" : "http://oauthapi.sany-test.com";
// export const CONTENT_URL = process.env.NODE_ENV === 'production' ? "https://cmsapi.sanyglobal.com" : "https://cmsapi.sanyglobal.com";
// export const CONTENT_URL = "http://192.168.1.166:86";
// export const adminUrl = process.env.NODE_ENV === 'production' ? "https://cms-admin.sanyglobal.com" : "https://cms-admin.sanyglobal.com";
export const CONTENT_URL = isProduction
  ? "https://market-service.sanyglobal.com"
  : "https://market-service-alitest.sanyglobal.com";
export const AUTH_URL = isProduction
  ? "https://oauthapi.sanyglobal.com"
  : "https://oauthapi-alitest.sanyglobal.com";
export const INQUIRY_URL = isProduction
  ? "https://inquiry-service.sanyglobal.com"
  : "http://inquiry-service-alitest.sanyglobal.com";



// WEBPACK FOOTER //
// ./src/util/config.js